(function () {
  'use strict';

  if (window.__budgiverseCollectionsPortalLoaded) return;
  window.__budgiverseCollectionsPortalLoaded = true;

  const portalSections = document.querySelectorAll('.budgiverse-collections-portal');
  const cleanupMap = new WeakMap();
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsCardHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  portalSections.forEach(initPortalSection);

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event?.target?.querySelector?.('.budgiverse-collections-portal') || event?.target;
    if (!section) return;

    const cleanup = cleanupMap.get(section);
    if (typeof cleanup === 'function') {
      cleanup();
      cleanupMap.delete(section);
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    const target = event?.target;
    const section = target?.matches?.('.budgiverse-collections-portal')
      ? target
      : target?.querySelector?.('.budgiverse-collections-portal');

    if (section && !cleanupMap.has(section)) initPortalSection(section);
  });

  function initPortalSection(section) {
    const cleanups = [];

    cleanups.push(initReveal(section));
    cleanups.push(initRealmAnalytics(section));

    if (!prefersReducedMotion && supportsCardHover) {
      cleanups.push(initPointerCards(section));
    }

    cleanupMap.set(section, () => {
      cleanups.forEach((cleanup) => {
        if (typeof cleanup === 'function') cleanup();
      });
    });
  }

  function initReveal(section) {
    const revealNodes = section.querySelectorAll('.portal-reveal');
    if (!revealNodes.length) return () => {};
    const timeoutIds = [];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const delay = parseInt(entry.target.dataset.revealDelay || '0', 10);
        const timeoutId = window.setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, delay);

        timeoutIds.push(timeoutId);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -40px 0px'
    });

    revealNodes.forEach((node) => observer.observe(node));

    return function cleanupReveal() {
      observer.disconnect();
      timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
    };
  }

  function initRealmAnalytics(section) {
    const realmLinks = section.querySelectorAll('.budgiverse-realm-card__link[data-analytics-realm]');
    if (!realmLinks.length) return () => {};

    const listeners = [];

    realmLinks.forEach((link) => {
      const handleClick = () => {
        const realm = link.dataset.analyticsRealm || '';
        const handle = link.dataset.analyticsHandle || '';

        window.budgiversePublishAnalyticsEvent?.('realm_entered', {
          realm,
          handle,
        });
      };

      link.addEventListener('click', handleClick, { passive: true });
      listeners.push(() => link.removeEventListener('click', handleClick));
    });

    return function cleanupRealmAnalytics() {
      listeners.forEach((removeListener) => removeListener());
    };
  }

  function initPointerCards(section) {
    const cards = section.querySelectorAll('[data-portal-card]');
    if (!cards.length) return () => {};

    const listeners = [];

    cards.forEach((card) => {
      const handleMove = (event) => {
        const rect = card.getBoundingClientRect();
        const relativeX = (event.clientX - rect.left) / rect.width;
        const relativeY = (event.clientY - rect.top) / rect.height;
        const tiltY = (relativeX - 0.5) * 6;
        const tiltX = (0.5 - relativeY) * 5;

        card.style.setProperty('--pointer-x', `${(relativeX * 100).toFixed(2)}%`);
        card.style.setProperty('--pointer-y', `${(relativeY * 100).toFixed(2)}%`);
        card.style.setProperty('--tilt-x', `${tiltX.toFixed(2)}deg`);
        card.style.setProperty('--tilt-y', `${tiltY.toFixed(2)}deg`);
      };

      const handleLeave = () => {
        card.style.setProperty('--pointer-x', '50%');
        card.style.setProperty('--pointer-y', '50%');
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      };

      card.addEventListener('pointermove', handleMove, { passive: true });
      card.addEventListener('pointerleave', handleLeave, { passive: true });
      card.addEventListener('pointercancel', handleLeave, { passive: true });

      listeners.push(() => {
        card.removeEventListener('pointermove', handleMove);
        card.removeEventListener('pointerleave', handleLeave);
        card.removeEventListener('pointercancel', handleLeave);
      });
    });

    return function cleanupPointerCards() {
      listeners.forEach((removeListener) => removeListener());
    };
  }
})();
